import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { TranscriptCacheService } from 'ngx/go-modules/src/services/transcript-cache/transcript-cache.service';

export const transcriptCacheServiceModule = angular.module('transcriptCacheServiceModule', [])
	.factory('transcriptCacheService', downgradeInjectable(TranscriptCacheService))
	.name;
